import axios from "axios";
import API_URL from "../constants/Connection";
import {useTranslation} from "react-i18next";


const token = window.localStorage.getItem("token");

export const useApi = () => {
    const {i18n} = useTranslation();
    return axios.create({
        baseURL: API_URL,
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Token ${token}`,
            "Accept-Language": i18n.language,
            "Access-Control-Allow-Origin": "*"
        },
    })
}


export const startQuiz = (api) => api.post("/current-quiz");

export const getCurrentQuiz = (api) => api.get("/current-quiz");

export const getCurrentQuestion = (api) => api.get("/current-quiz/current-question");

export const getLastQuizResults = (api) => api.get("/results/last");

export const getUserQuizzes = (api) => api.get("/my-quizzes");

export const submitAnswerMultChoice = (api, answerId) => api.post("/current-quiz/current-question", {"correct": answerId});

export const submitAnswerTrueFalse = (api, {answers}) => api.post("/current-quiz/current-question", {answers});

export const submitAnswerWriteAnswer = (api, answer) => api.post("/current-quiz/current-question", {"answer": answer});

export const submitAnswerSequence = (api, options) => api.post("/current-quiz/current-question", options);

export const submitAnswerGaps = (api, gaps) => api.post("/current-quiz/current-question", gaps);

export const submitAnswerDragDrop = (api, categories) => api.post("/current-quiz/current-question", categories);

export const quizGiveUp = (api) => api.post("/current-quiz/give-up");

export const getSubcategories = (api) => api.get("/preferences/subcategories");

export const postSubcategories = (api, {subcategories}) => api.post("/preferences/subcategories", {subcategories});

export const getReviews = (api) => api.get("/reviews");

export const postReview = (api, review) => api.post("/reviews", review);